import React, { useContext, useEffect } from 'react';
import DailyEngagedUsersContext from '../../../../contexts/DailyEngagedUsersContext';
import { DailyEngagedUserContainer } from '../styles';
import CompiledDailyEngagedUsers from './CompiledDailyEngagedUsers';
import DailyEngagedUserMonthlyUsage from './DailyEngagedUserMonthlyUsage';
import DailyEngagedUserUsage from './DailyEngagedUserUsage';

const DailyEngagedUsersSummaryComponent: React.FC = () => {
  const { tenant, content, setHeaderContent } = useContext(DailyEngagedUsersContext);

  useEffect(() => {
    setHeaderContent({
      redirect: '/data-consumption',
      text: content.formatString(content.header, tenant.info.name),
    });
    return () => setHeaderContent({ redirect: null });
  }, []);

  return (
    <DailyEngagedUserContainer>
      <CompiledDailyEngagedUsers></CompiledDailyEngagedUsers>
      <DailyEngagedUserMonthlyUsage />
      <DailyEngagedUserUsage />
    </DailyEngagedUserContainer>
  );
};

export default DailyEngagedUsersSummaryComponent;
